import { render } from "./ComInfoButton.vue?vue&type=template&id=4ee08a28&ts=true"
import script from "./ComInfoButton.vue?vue&type=script&lang=ts"
export * from "./ComInfoButton.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__